/*
 *   Copyright (c) 2020
 *   All rights reserved.
 */
import $ from 'jquery';
import {
    prefix
} from './globals';
import {
    BaseForm,
    EMAIL_REG, MESSAGE_ONLY_NUMBER,
    MESSAGE_REQUIRED, ONLY_NUMBER_REG,
    URL_REG,
} from './form/BaseForm'

class OurPartnersForm extends BaseForm {
    constructor() {
        super();

        this.$form = $(`.${prefix}-our-partners-form`);

        if (this.$form.length === 0)
            return;

        this.init();
    }

    init() {
        this.sending = false;
        this.$companyNameInput = this.$form.find('#clf-opcompany');
        this.$contactNameInput = this.$form.find('#opcontact');
        this.$emailInput = this.$form.find('#opemail');
        this.$phoneInput = this.$form.find('#opphone');
        this.$websiteInput = this.$form.find('#opwebsite');
        this.$messageInput = this.$form.find('#opmsg');
        this.$ageCheckInput = this.$form.find('#age-checked-form');
        this.$submitButton = this.$form.find('#our-partners-submit-form');

        this.$submitButton.on('click', this.onSubmitButton);
        this.initValidationFields();
        this.assignElementOnlyAllowNumber(this.$phoneInput);
        this.onCheckBoxKey();
    }

    initValidationFields = () => {
        this.fieldsValidation = {
            companyName: {
                $field: this.$companyNameInput,
                type: 'text',
                rules: [
                    {
                        required: true,
                        message: MESSAGE_REQUIRED
                    },
                ]
            },
            contactName: {
                $field: this.$contactNameInput,
                type: 'text',
                rules: [
                    {
                        required: true,
                        message: MESSAGE_REQUIRED
                    },
                ]
            },
            email: {
                $field: this.$emailInput,
                type: 'text',
                rules: [
                    {
                        required: true,
                        message: MESSAGE_REQUIRED
                    },
                    {
                        regex: EMAIL_REG,
                        message: 'Please enter a valid email address.',
                    },
                ]
            },
            phone: {
                $field: this.$phoneInput,
                type: 'text',
                rules: [
                    {
                        required: true,
                        message: MESSAGE_REQUIRED
                    },
                    {
                        regex: ONLY_NUMBER_REG,
                        message: MESSAGE_ONLY_NUMBER,
                    },
                ]
            },
            website: {
                $field: this.$websiteInput,
                type: 'text',
                rules: [
                    {
                        required: true,
                        message: MESSAGE_REQUIRED
                    },
                    {
                        regex: URL_REG,
                        message: 'Please enter a valid url.',
                    },
                ]
            },
            message: {
                $field: this.$messageInput,
                type: 'textarea',
                rules: [
                    {
                        required: true,
                        message: MESSAGE_REQUIRED
                    },
                ]
            },
            age: {
                $field: this.$ageCheckInput,
                type: 'checkbox',
                rules: [
                    {
                        checked: true,
                        message: 'This must be checked.'
                    },
                ]
            },
        };
    }

    onSubmitButton = (e) => {
        e.stopPropagation();
        e.preventDefault();

        if (this.validateForm()) {
            this.onSubmitForm();
        }

        return false;
    }

    validateCheckbox = (evt) => {
        const $this = $(evt.currentTarget);

        if (!(this.$ageCheckInput.is(':checked') && this.$igCheckInput.is(':checked'))) {
            $('.get-involved-form-error').remove();
        }
    }

    onCheckBoxKey = () => {
        const $self = this;
        $("#age-checked-form").keydown(function (event) {
            if (event.keyCode === 13) {
                $self.validateCheckbox();
            }
        });
    }

    onSubmitForm = () => {
        if (this.sending) return;

        this.sending = true;
        this.$submitButton.after(`<div class="${prefix}-loader">Loading...</div>`);
        this.$submitButton.remove();

        const currentDate = new Date(),
            timestamp = currentDate.getTime(),
            data = {
                u: 'c3ebcdb095cc3ea77bae0d533',
                id: '5c0d8f6f70',
                c: 'jQuery190014486088887783577_1607636841611',
                MMERGE20: this.$companyNameInput.val(),
                MMERGE21: this.$contactNameInput.val(),
                MMERGE22: this.$phoneInput.val(),
                EMAIL: this.$emailInput.val(),
                MMERGE23: this.$websiteInput.val(),
                MMERGE24: this.$messageInput.val(),
                b_c3ebcdb095cc3ea77bae0d533_5c0d8f6f70: "",
                subscribe: 'Send',
                _: timestamp,
            },
            url = 'https://claralionelfoundation.us14.list-manage.com/subscribe/post-json?';

        $.ajax({
            type: 'GET',
            url: url + (new URLSearchParams(data).toString()),
            crossDomain: true,
            success: (data) => {
                this.$form.addClass('hide');
                this.$form.after(
                    '<div class="get-involved-message"><h4>Thank you for subscribing!</h4></div><div></div>'
                );
                this.sending = false;
            },
            error: (err) => {
                this.$form.addClass('hide');
                this.$form.after(
                    '<div class="get-involved-message"><h4>Thank you for subscribing!</h4></div>'
                );
                this.sending = false;
            },
        });
    }
}

export default OurPartnersForm;
